import { createSlice } from '@reduxjs/toolkit';
import {
  getPaymentBotDetSTatPaymentsThunk,
  getPaymentBotMonthStatThunk,
  getPaymentBotStatThunk,
  getPaymonExportStatThunk,
} from './statisticsActions';

const initialState = {
  stat: null,
  loading: null,
  error: null,
  export: null,
  paym: null
};

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(getPaymentBotStatThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getPaymentBotStatThunk.fulfilled, (state, action) => {
        state.stat = action.payload;
        state.loading = false;
      })
      .addCase(getPaymentBotStatThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getPaymentBotMonthStatThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getPaymentBotMonthStatThunk.fulfilled, (state, action) => {
        state.stat = action.payload;
        state.loading = false;
      })
      .addCase(getPaymentBotMonthStatThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(getPaymentBotDetSTatPaymentsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getPaymentBotDetSTatPaymentsThunk.fulfilled, (state, action) => {
        state.paym = action.payload;
        state.loading = false;
      })
      .addCase(getPaymentBotDetSTatPaymentsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(getPaymonExportStatThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getPaymonExportStatThunk.fulfilled, (state, action) => {
        state.export = action.payload;
        state.loading = false;
      })
      .addCase(getPaymonExportStatThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });

  },
});

export default statisticsSlice.reducer;
